import { render, staticRenderFns } from "./parts_reserv.vue?vue&type=template&id=e653e1f4&scoped=true&"
import script from "./parts_reserv.vue?vue&type=script&lang=js&"
export * from "./parts_reserv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e653e1f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e653e1f4')) {
      api.createRecord('e653e1f4', component.options)
    } else {
      api.reload('e653e1f4', component.options)
    }
    module.hot.accept("./parts_reserv.vue?vue&type=template&id=e653e1f4&scoped=true&", function () {
      api.rerender('e653e1f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/create/mem_preview/addon/parts/parts_reserv/parts_reserv.vue"
export default component.exports